import ArrowIcon from "./Arrow.png";

interface DownloadTipProps {
  visible: boolean;
  onClose: () => void;
}

const DownloadTip: React.FC<DownloadTipProps> = ({ visible, onClose }) => {
  return (
    <div className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 ${visible ? "flex" : "hidden"} flex-col items-center justify-start z-50`} onClick={onClose}>
      <img src={ArrowIcon} alt="weixin-tip" className="w-50% ml-50%" />
      <div className="mt-4 text-3.5 font-400 lh-5 color-#fff">点击右上角</div>
      <div className="mt-4 text-3.5 font-400 lh-5 color-#fff">选择“在浏览器中打开”，即可下载</div>
    </div>
  );
};

export default DownloadTip;
